import { Helmet } from "react-helmet-async";

/**
 * SEO — per-page meta tags using react-helmet-async.
 * Wrap once in App.js with <HelmetProvider> and drop <SEO ... /> on every page.
 */
export default function SEO({
    title,
    description,
    canonical,
    image,
    keywords,
    type = "website",
    jsonLd,
    noindex = false,
}) {
    const fullTitle = title?.includes("FlowLux") ? title : `${title} · FlowLux`;
    const url = canonical ? `https://flowlux.co${canonical}` : undefined;
    const ogImage =
        image ||
        "https://flowlux.co/og-image.png";

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {url && <link rel="canonical" href={url} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            {url && <meta property="og:url" content={url} />}
            <meta property="og:image" content={ogImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={ogImage} />

            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}
